import './style.scss';
import squarePhoneOrange from '../../../../assets/icons/phone-square-orange.svg';
import DataUrlHelper from '../../../helpers/data-url.helper';
import { TranslationService } from '../../../services/translation.service';

function BookingIcon({ className }: { className?: string }) {
  return <img src={DataUrlHelper.encode(squarePhoneOrange)} alt={TranslationService.get('common.icons.phonesquareorange')} className={`note-icon ${className ?? ''}`} />;
}

export default BookingIcon;
